import styled from "@emotion/styled";

import type { FormValues } from "../forms";
import { FieldResizingTextarea, Form, FormikForm, FormRowField } from "../forms";

const PlaceholderInputBase = styled(FieldResizingTextarea)`
  background: transparent;
  border: none;
  color: #fff;
  outline: none;

  &::placeholder {
    color: inherit;
    opacity: 0.5;
  }
`;

const PlaceholderInputBaseLarge = styled(PlaceholderInputBase)`
  font-size: 30px;
  line-height: 36px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const PlaceholderInputBaseRegular = styled(PlaceholderInputBase)`
  font-size: 24px;
  line-height: 24px;

  @media (max-width: 1024px) {
    font-size: 18px;
    line-height: 18px;
  }
`;

type PlaceholderInputProps = {
  large?: boolean;
  value?: string;
  dataTestId?: string;
  placeholder?: string;
  onChange: (value: string) => void;
};

export const PlaceholderInput = ({ value = "", placeholder = "", large = false, onChange }: PlaceholderInputProps) => {
  const initialValues = { value };

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={({ value: newValue }) => onChange(newValue)}
      submitOnBlur
      dataTest="placeholder-input-form"
    >
      <Form>
        <FormRowField<FormValues> name="value">
          {large ? (
            <PlaceholderInputBaseLarge placeholder={placeholder} rows={1} />
          ) : (
            <PlaceholderInputBaseRegular placeholder={placeholder} rows={1} />
          )}
        </FormRowField>
      </Form>
    </FormikForm>
  );
};
